import axios from 'axios'
// const hostURL = "http://localhost:3034";
const hostURL = ''
const localURL = ''
const appName = '/bt'
const apiURL = `/api`
const version = `/v1`
const baseURL = `${hostURL}${appName}${apiURL}`
let httpAuth = axios.create({
	baseURL: `${hostURL}${appName}`,
	timeout: 30000,
	headers: {
		'Content-Type': 'application/json'
	}
})
let http = axios.create({
	baseURL: baseURL,
	timeout: 30000,
	headers: {
		'Content-Type': 'application/json'
	}
})

export default http
export { http, httpAuth, localURL, appName, baseURL }
